/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

export type PriorAuthCommandRejectionT =
  (typeof PriorAuthCommandRejectionT)[keyof typeof PriorAuthCommandRejectionT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriorAuthCommandRejectionT = {
  ACTION_NOT_ALLOWED: "ACTION_NOT_ALLOWED",
  DOSESPOT_CASE_NOT_CONFIRMED: "DOSESPOT_CASE_NOT_CONFIRMED",
  DOSESPOT_REJECTED: "DOSESPOT_REJECTED",
  OPERATION_IN_PROGRESS: "OPERATION_IN_PROGRESS",
  PRESCRIBER_REQUIRED: "PRESCRIBER_REQUIRED",
  DECISION_NOT_ALLOWED: "DECISION_NOT_ALLOWED",
  ELIGIBILITY_REQUIRED: "ELIGIBILITY_REQUIRED",
  PRESCRIPTION_READ_FAILED: "PRESCRIPTION_READ_FAILED",
} as const;
